import { Component, Input, OnInit } from '@angular/core'
import { ThemeSwitcherService } from '../../../../core/services/theme-switcher.service'

@Component({
    selector: 'app-form-section',
    templateUrl: './form-section.component.html',
    styleUrls: ['./form-section.component.scss'],
})
export class FormSectionComponent implements OnInit {
    @Input() title = ''
    @Input() bodyStyle: { [cssClass: string]: any } = {}
    @Input() sectionStyle!: { [cssClass: string]: any }
    @Input() useHorizontalScroll = false
    @Input() isLoading = false

    constructor(public themeService: ThemeSwitcherService) {}

    ngOnInit(): void {}
}
